import { message } from 'antd';
import { kevinAuthAPI, kevinCommonAPI } from 'apis/config';
import { handleMessage } from 'utils/helper/message';

export const charactersApis = {
  charactersList: (projectId) =>
    kevinAuthAPI.get(`/profile/${projectId}`).then((res) => res.data),
  charactersDetailList: () =>
    kevinAuthAPI.get(`/profile/details`).then((res) => res.data),
  charactersCreate: (projectId, data) =>
    kevinAuthAPI.post(`/profile/${projectId}`, data).then((res) => res.data),
  charactersCopy: (targetProjectId, sourceProfileId, data) =>
    kevinAuthAPI
      .post(`/profile/copy/${targetProjectId}/${sourceProfileId}`, data)
      .then((res) => res.data),
  charactersDelete: (projectId, id) =>
    kevinAuthAPI.delete(`/profile/${projectId}/${id}`).then((res) => res.data),

  // 프로필 업데이트
  characterUpdate: (projectId, id, data) =>
    kevinAuthAPI
      .patch(`/profile/${projectId}/${id}`, data)
      .then((res) => res.data)
      .catch((err) => {
        console.log(err.response.data);
        handleMessage(message, 'error', err.response.data.message);
      }),

  charactersDeleteAbility: (projectId, profileId, ability_id) =>
    kevinAuthAPI
      .delete(`/profile/${projectId}/${profileId}/ability/${ability_id}`)
      .then((res) => res.data),
  characterCreateAbility: (projectId, profileId, data) =>
    kevinAuthAPI.post(`/profile/${projectId}/${profileId}/ability`, data),
  characterUpdateAbility: (projectId, profileId, abilityId, data) =>
    kevinAuthAPI
      .patch(`/profile/${projectId}/${profileId}/ability/${abilityId}`, data)
      .then((res) => res.data),
  characterLineCondition: (lang) =>
    kevinCommonAPI.get(`/common/localize/line_condition?lang=${lang}`),
  characterMotions: (projectId, characterName) =>
    kevinCommonAPI.get(`/common/profile/${projectId}/motion/${characterName}`),
  uploadAbilityIcon: (projectId, profileId, abilityId, data) =>
    kevinAuthAPI
      .put(`/profile/${projectId}/${profileId}/ability/${abilityId}`, data)
      .then((res) => res.data),
};
